import React, { ChangeEvent, Fragment, FunctionComponent, useState } from "react";
import { connect, MapStateToProps, MergeProps } from "react-redux";

import { Divider, Text, VerticalDivider, WhiteSpace } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";
import { IAppState } from "@multiweb/types/react";
import { isWorkflowReadOnly } from "../../../selectors";
import { WorkflowEditorProps } from "../../../types";
import { AutoTextArea } from "./AutoTextArea";

type EditableItemComponentProps = {
    readonly isSelected: boolean;
    readonly readOnly?: boolean;
    readonly textType: string;
    readonly caption: string;
    readonly message: string;
    readonly onClick: () => void;
    readonly onCaptionChange: (e: ChangeEvent<HTMLInputElement>) => void;
    readonly onConfirmMessageChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
};

const classNames = bemClassNames("editable-item-component");
const langTypeAreaClassName = classNames("lang-type-area");
const captionInputClassName = classNames("caption-input");

const EditableItemComponent: FunctionComponent<EditableItemComponentProps> = ({ isSelected, textType, readOnly, caption, message, onClick, onCaptionChange, onConfirmMessageChange }) => {
    const [isMouseOver, setIsMouseOver] = useState(false);

    const onMouseOver = () => {
        if (!isMouseOver)
            setIsMouseOver(true);
    };

    const onMouseLeave = () => {
        if (isMouseOver)
            setIsMouseOver(false);
    };

    return (
        <Fragment>
            <div className={classNames({ "is-mouse-over": isMouseOver, "selected": isSelected })} {...{ onClick, onMouseOver, onMouseLeave }}>
                <div className={langTypeAreaClassName}>
                    <Text value={textType} title={textType} ellipsis whiteSpace={WhiteSpace.nowrap} />
                </div>
                <VerticalDivider />
                <input readOnly={readOnly} onChange={onCaptionChange} value={caption} className={captionInputClassName} />
                <VerticalDivider />
                <AutoTextArea readOnly={readOnly} onChange={onConfirmMessageChange} textValue={message} />
            </div>
            <Divider />
        </Fragment>
    );
};

type EditableItemProps = EditableItemComponentProps & WorkflowEditorProps;

type StateProps = {
    readonly isWorkflowReadOnly: boolean;
};

const mapStateToProps: MapStateToProps<StateProps, EditableItemProps, IAppState> = (state, { hostKey }) => ({
    isWorkflowReadOnly: isWorkflowReadOnly(state, hostKey),
});

const mergeProps: MergeProps<StateProps, undefined, EditableItemProps, EditableItemComponentProps> = ({ isWorkflowReadOnly }, _dispatychProps, ownProps) => ({
    ...ownProps,
    readOnly: isWorkflowReadOnly || ownProps.readOnly,
});

export const EditableItem = connect(mapStateToProps, undefined, mergeProps)(EditableItemComponent);
